import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesTF,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import LockIcon from "@material-ui/icons/Lock";

import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";

import { sto } from "../../../../../Context/InshData";
import ShiftsTables from "./ShiftsTables";
import ShiftsReportTable from "./ShiftsReportTable";
import ShiftsReportForm from "./ShiftsReportForm";
import { useStylesLbl } from "../../../../../St/Reports/UseStyle";
import ExitConfirmDialog from "../../../../../components/ExitConfirmDialog";
import ShiftsPrint from "../../../../../Reviews/Sales/Shiftt/ShiftsPrint";
import { isMobileDevice } from "../../../../Accounts/BackEnd/receipt-voucher/external-exchange-voucher/EExchangeVoucher";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function ShiftsReport(props) {
    const { AutoOptions, isPurches } = props;
    const { t } = useTranslation(["forms", "translation"]);

    const shiftOptions = [
        { id: 0, name: t("opened") },
        { id: 1, name: t("closed") },
    ];
    const SearchCloseReports = {
        transFrom: {},
        transTo: {},
        // dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        dateFrom: moment(new Date().setDate(new Date().getDate() - 3)).format("YYYY-MM-DD"),
        dateFromAll: moment(new Date()).subtract().format("YYYY") + "-01-01",

        timeFrom: moment(new Date()).format('HH:mm'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        trans_Close: shiftOptions[0],
        user: AutoOptions.Users[0],
        branch: sto.branchi,
    };
    function GetFromOptions(id, options) {
        const index = options?.findIndex((op) => op.id == id);
        return options[index];
    }
    const defaultShifts = {
        transFrom: {},
        transTo: {},
        dateFrom: moment(new Date()).subtract().format("YYYY") + "-01-01",
        timeFrom: moment(new Date()).format('HH:mm'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        trans_Close: shiftOptions[0],
        user: sto.User_typei === 1 ? { id: -1, name: "all" } : GetFromOptions(sto.idi, AutoOptions.Users),
        // user:sto.user_id,
        branch: sto.branchi,
    };
    const defPermUser = {
        userEmp: 0,
        useShift: 0,
        accClose: 0,
        accPlus: 0,
        accMinus: 0,
        minusAmount: 0,
        plusAmount: 0,
        saleAmount: Number(0),
        deffAmount: 0,
        closeShift: 0,

    };

    const [rptParams, setRptParams] = React.useState(SearchCloseReports);
    const [rptParamsDef, setRptParamsDef] = React.useState(defaultShifts);

    const [optionsShifts, setOptionsShifts] = useState(AutoOptions?.Shifts);
    const [allowShifts, setAllowShifts] = useState(true);
    const [showButtons, setShowButtons] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);

    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [dataShifts, setDataShifts] = useState([]);
    const [shiftsRow, setShiftsRow] = useState({});
    const [permUser, setPermUser] = useState(defPermUser);

    const [fetching, setFetching] = useState(false);
    const [fetchingS, setFetchingS] = useState(false);

    const [sum, setSum] = useState(false);
    const [showDef, setShowDef] = useState(true);

    const [exitDialog, setExitDialog] = useState({ isOpen: false });

    const viewHandle = async () => {

        setDataShifts([]);
        setFetchingS(true);
        await axios
            .get(
                uri +
                `RptSales/getShifts?dateF=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&dateT=${rptParams.dateTo + ' ' + rptParams.timeTo}
               &&branch=${rptParams?.branch}
    &&user=${rptParams.user?.id}
    &&trans_Close=${rptParams?.trans_Close?.id}
    &&transFrom=${rptParams?.transFrom?.trans_no}
    &&transTo=${rptParams?.transTo?.trans_no}`
            )
            .then((res) => {
                setDataShifts(res?.data);
                // console.log(" the data is", res.data);
                setFetchingS(false);
            })
            .catch((err) => {
                // console.log(err);
                // toast.err("يوجد خطأ في الجلب");
                setFetchingS(false);
            });
        // }
    };

    const viewHandleBegin = async () => {

        setDataShifts([]);
        setFetchingS(true);
        setShowDef(true);
        await axios
            .get(
                uri +
                `RptSales/getShiftsDefault?dateF=${rptParams.dateFromAll + ' ' + rptParams.timeFrom}
        &&dateT=${rptParams.dateTo + ' ' + rptParams.timeTo}
               &&branch=${sto.branchi}
    &&user=${rptParams.user?.id ?? -1}
    &&trans_Close=${0}
    &&transFrom=${1}
    &&transTo=${1}`
            )
            .then((res) => {
                setDataShifts(res?.data);
                // console.log(" the data is", res.data);
                setFetchingS(false);
                setShowDef(false);

            })
            .catch((err) => {
                // console.log(err);
                // toast.err("يوجد خطأ في الجلب");
                setFetchingS(false);
            });
        // }
    };

    const viewSearch = async (rowData) => {
        setData([]);
        setFetching(true);
        setShowButtons(false);
        setShiftsRow(rowData);
        await axios
            .get(
                uri +
                `RptSales/ShiftsReport?dateF=${rowData?.minDate}
        &&dateT=${rowData?.maxDate}
    &&branch=${rowData?.branchId}
    &&user=${rowData?.empId}
    &&trans_Close=${rowData?.transClose}
    &&trans_no=${rowData?.transNo}`
            )
            .then((res) => {
                setData(res.data);
                if (parseFloat(res.data?.userPerm?.recive_amount)>0){
                    let i = {
                        res: Number(res.data?.userPerm?.recive_amount),
                        cash: Number(data?.totals?.totRsedStok),
                    }
                    let deftot = i.res - i.cash;
                    setPermUser({ ...res.data.userPerm, saleAmount: i.res, deffAmount: parseFloat(deftot).toFixed(2) });
                }else{
                    setPermUser({ ...res.data.userPerm, saleAmount: 0, deffAmount: 0 });
                }
                console.log(" the data is", res.data);
                setFetching(false);
                setShowButtons(true);
            })
            .catch((err) => {
                setFetching(false);
                setPermUser(defPermUser);
                console.log(err);
                // toast.err("يوجد خطأ في الجلب");
                setData([]);
                setShowButtons(false);
            });

    };
    const his = useHistory();

    const shitCloseEnd = (rowdata) => {
        var otherData = dataShifts?.shiftsAll.filter((obj) => obj.transNo !== rowdata.transNo);
        setDataShifts([...otherData]);
        setShowButtons(false);
    }
    const [dataPrint, setDataPrint] = useState({});
    const [infoPrint, setInfoPrint] = useState(false);
    const closePrint = (type) => {
        setDataPrint({});
        setInfoPrint(false);
    };
    const isSavingRef = useRef(false);

    const printHandleA4 = (dataS, dataT) => {
        if (data.lenght == 0) {
            alert("لاتوجد بيانات");
        } else {
            setData([]);
            isSavingRef.current = false;
            // shitCloseEnd(shiftsRow);
            setShiftsRow({});
            const info = {
                data: dataT?.shiftsData,
                tot: dataT?.totals,
                kind: 1,
                from: 'الحركة اليومي',
                title: ' تقرير ملخص  اقفال وردية الموظف ',
                user: rptParams.user.name,
                fDate: dataS.minDate,
                tDate: dataS.maxDate,
                user: rptParams.user.name,
                trans_no: dataS.transNo,
                isLarge: true,
                kind: 1,
                nDate: moment(new Date()).format('YYYY-MM-DD'),
                // totsp:rpt.totSelcPeriod,balncsp:rpt.balncSelcPeriod
            }
            setDataPrint(info);
            setInfoPrint(true);
            // localStorage.setItem("iInfos", JSON.stringify(info));
            // his.push({ pathname: "/ReviewShifts" });
            // window.location.reload(true);
        }
    };

    const printHandleCashier = (dataS, dataT) => {

        if (data.lenght == 0) {
            alert("لاتوجد بيانات");
        } else {
            setData([]);
            setShiftsRow({});
            isSavingRef.current = false;
            const info = {
                // rout:rpt.parms,
                data: dataT?.shiftsData,
                tot: dataT?.totals,
                from: 'الحركة اليومي',
                title: ' تقرير اقفال وردية الموظف ',
                stock: "",
                safe: "",
                user: rptParams.user.name,
                fDate: dataS.minDate,
                kind: 1,
                tDate: dataS.maxDate,
                transNo: dataS.transNo,
                isLarge: false,
                nDate: moment(new Date()).format('YYYY-MM-DD'),
            }
            setDataPrint(info);
            setInfoPrint(true);
            // localStorage.setItem("iInfos", JSON.stringify(info));
            // his.push({ pathname: "/" });
            // window.location.reload(true);
        }
    };
    const printHandleGroups = async (dataS, dataT) => {
        console.log(" the  data is", dataS);
        console.log(" the  dataT is", dataT);

        if (data.lenght == 0) {
            alert("لاتوجد بيانات");
        } else {
            await axios
                .get(
                    uri +
                    `RptSales/ShiftsByGroups?dateFrom=${dataS?.minDate}
        &&dateTo=${dataS?.maxDate}
    &&branch=${dataS?.branchId ?? 1}
    &&emp_id=${dataS?.empId}
    &&trans_no=${dataS?.transNo}`
                )
                .then((res) => {
                    setShiftsRow({});
                    isSavingRef.current = false;
                    const info = {
                        // rout:rpt.parms,
                        data: dataT?.shiftsData,
                        tot: dataT?.totals,
                        dataGroups: res.data,
                        from: 'الحركة اليومي',
                        title: ' تقرير اقفال وردية الموظف ',
                        stock: "",
                        safe: "",
                        isGroup: true,
                        user: rptParams.user.name,
                        fDate: dataS.minDate,
                        kind: 1,
                        tDate: dataS.maxDate,
                        transNo: dataS.transNo,
                        isLarge: false,
                        nDate: moment(new Date()).format('YYYY-MM-DD'),
                    }
                    setDataPrint(info);
                    setInfoPrint(true);
                })
                .catch((err) => {
                    // setPermUser(defPermUser);
                    // console.log(err);
                    // setData([]);
                    // setShowButtons(false);
                });
        }
    };
    const loadOptinsShift = async (user_id, trnclose, fromData, todate) => {
        setOptionsShifts([]);
        await axios
            .get(
                uri +
                `RptSales/shiftOptions?dateF=${fromData + ' ' + rptParams?.timeFrom}
        &&dateT=${todate + ' ' + rptParams?.timeTo}
        &&branch=${rptParams?.branch}
        &&user=${user_id}
        &&trans_Close=${trnclose}`
            )
            .then((res) => {
                setAllowShifts(false);
                setOptionsShifts(res?.data?.shiftOptions);
            })
            .catch((err) => {
                console.log(err);
                // toast.err("يوجد خطأ في الجلب");
            });
    };

    const CloseShift = (props, dataR, dataST) => {
        if (isSavingRef.current) return;
        isSavingRef.current = true;
        const ShiftsClose = {
            sales_emp: shiftsRow.empId,
            branch: shiftsRow.branchId,
            trans_no: shiftsRow.transNo,
            saleTotal: permUser?.saleAmount ?? 0,
            stockTotal: data?.totals?.totRsedStok ?? 0,
            useClose: permUser?.useClose ?? 0,
            acc_close: permUser?.accClose ?? 0,
            acc_plus: permUser?.accPlus ?? 0,
            acc_minus: permUser?.accMinus ?? 0,
            transClose: shiftsRow?.transClose,
            trans_start_date: shiftsRow?.minDate,
            trans_end_date: shiftsRow?.maxDate,
            plus_amount:parseFloat(permUser.deffAmount??0) > 0 ? permUser.deffAmount : 0,
            minus_amount: parseFloat(permUser.deffAmount??0) < 0 ? parseFloat(-1*permUser.deffAmount ): 0,
            recive_amount: parseFloat(permUser.saleAmount??0)??0,
        };
        if (shiftsRow.transClose == 1 && !openUpdate) {
            alert("الوردية قد تم اغلاقها مسبقا")
        } else {
            console.log("the curre data is ", ShiftsClose);
            axios
                .put(uri + "Shifts", ShiftsClose)
                .then((res) => {
                    if (res.data > 1) {
                        toast.success("تم الاقفال بنجاح");
                        setData([]);
                        // shitCloseEnd(shiftsRow);
                        shitCloseEnd({ ...ShiftsClose });
                        setPermUser(defPermUser);
                        setShiftsRow({});
                        setExitDialog({ isOpen: false });

                        if (props === "close") {

                        } else if (props === "small") {
                            printHandleCashier(dataR, dataST);

                        }
                        else if (props === "big") {
                            printHandleA4(dataR, dataST);

                        }
                        isSavingRef.current = false;
                    } else {
                        toast.success("تم الاقفال بنجاح");
                        setData([]);
                        // shitCloseEnd(shiftsRow);
                        shitCloseEnd({ ...ShiftsClose });

                        setShiftsRow({});
                        if (props === "close") {

                        } else if (props === "small") {
                            printHandleCashier(dataR, dataST);

                        }
                        else if (props === "big") {
                            printHandleA4(dataR, dataST);

                        }
                        isSavingRef.current = false;

                    }
                })
                .catch((res) => {
                    //  alert("تم إضافة الصنف هذا مسبقا");
                    toast.success("لم يتم الاقفال بنجاح");
                    isSavingRef.current = false;
                })
        }

    };


    const changTFieldFrom = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
        loadOptinsShift(rptParams?.user?.id, rptParams?.trans_Close?.id, e.target.value, rptParams?.dateTo);
    };

    const changTFieldTo = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
        loadOptinsShift(rptParams?.user?.id, rptParams?.trans_Close?.id, rptParams?.dateFrom, e.target.value);
    };
    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };

    const onChangeAutoUsers = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });

        loadOptinsShift(newValue?.id, rptParams?.trans_Close?.id, rptParams?.dateFrom, rptParams?.dateTo);
    };
    const onChangeAutoTransC = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });

        loadOptinsShift(rptParams?.user?.id, newValue.id, rptParams?.dateFrom, rptParams?.dateTo);
    };
    const changAmountdata = (prop) => (event) => {
        let i = {
            res: Number(event.target.value),
            cash: Number(data?.totals?.totRsedStok),
        }
        let deftot = i.res - i.cash;
        setPermUser({ ...permUser, saleAmount: i.res, deffAmount: parseFloat(deftot).toFixed(2) });
    }
    const claslbls = useStylesLbl();
    const clasTF = useStylesTF();
    let isUser = true;
    const showCashOnly = sto?.show_only_shiftcash ?? false;

    const checkcloseShift = (type, shiftsRow, data) => {
        if ((parseInt(permUser?.accClose) > 0 && parseInt(permUser?.accPlus) > 0 && parseInt(permUser?.accMinus) > 0
            && permUser?.useShift) && parseFloat(permUser.saleAmount) <= 0) {
            alert("write your cash amount");
        } else {
            setExitDialog({
                isOpen: true,
                text: "هل انت متأكد من إغلاق الورديه ",
                onConfirm: () => {
                    CloseShift(type, shiftsRow, data);
                },
            });
        }
    };
    useEffect(() => {
        if (showDef) {
            viewHandleBegin();
            // console.log(" showCashOnly",showCashOnly)
        }
    }, [showDef]);

    useEffect(() => {
        if (isMobileDevice()) return;

        const handleKeyDown = async (event) => {
            if (event.ctrlKey && event.key === "u") {
                event.preventDefault();
                if (data && parseInt(permUser?.accClose) > 0 && parseInt(permUser?.accPlus) > 0 && parseInt(permUser?.accMinus) > 0
                    && permUser?.useShift && shiftsRow.transClose === 1) {
                    setOpenUpdate(true);
                }

            }

        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [permUser,shiftsRow,openUpdate,setOpenUpdate]);
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                >
                    {t("shift_close_report")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip}>

                    <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <ShiftsReportForm
                                {...{
                                    AutoOptions,
                                    rptParams,
                                    onChangeData,
                                    onChangeAutoData,
                                    optionsShifts,
                                    allowShifts,
                                    onChangeAutoUsers,
                                    shiftOptions,
                                    onChangeAutoTransC,
                                    changTFieldFrom,
                                    changTFieldTo,

                                }}
                            />
                            <Grid item container justifyContent="center" xs={12}>
                                <BeatLoader loading={fetchingS} color={colors.green[300]} />
                                {!fetchingS && (
                                    <ShiftsTables
                                        {...{
                                            data: dataShifts?.shiftsAll ? dataShifts?.shiftsAll : [],
                                            viewSearch, CloseShift, showButtons
                                        }}
                                    />
                                )}

                            </Grid>
                            <Grid
                                item
                                container

                                justifyContent="center"
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                spacing={1}
                            >
                                <Hidden smUp={["sm"]}>

                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<ScannerIcon />}
                                            size="large"
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            className={[clasui.button]}
                                            onClick={() => viewHandle()}
                                        >
                                            {t("forms:show")}
                                        </Button>
                                    </Grid>
                                </Hidden>
                                <Hidden only={["xs"]}>
                                    {!showDef && (
                                        <Grid item>
                                            <Button
                                                disabled={fetchingS}
                                                variant="contained"
                                                startIcon={<ScannerIcon />}
                                                size="large"
                                                style={
                                                    (inshst.sal.iconBtn,
                                                        { borderRadius: 0 })
                                                }
                                                className={[clasui.button]}
                                                onClick={() => viewHandleBegin()}
                                            >
                                                {t("forms:all")}
                                            </Button>
                                        </Grid>
                                    )}
                                    <Grid item>
                                        <Button
                                            disabled={fetchingS}
                                            variant="contained"
                                            startIcon={<ScannerIcon />}
                                            size="large"
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            className={[clasui.button]}
                                            onClick={() => viewHandle()}
                                        >
                                            {t("forms:view")}
                                        </Button>
                                    </Grid>
                                </Hidden>

                                {showButtons && shiftsRow.transClose == 0 && (
                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<LockIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => checkcloseShift("close", shiftsRow, data)}

                                        >
                                            {t("closing")}
                                        </Button>
                                    </Grid>
                                )}
                                {showButtons && shiftsRow.transClose == 0 && (
                                    <>
                                        <Grid item>
                                            <Button
                                                disabled={showCashOnly ? true : fetching}
                                                variant="contained"
                                                startIcon={<PrintIcon />}
                                                color="primary"
                                                size="large"
                                                className={[clasui.button]}
                                                style={
                                                    (inshst.sal.iconBtn,
                                                        { borderRadius: 0 })
                                                }
                                                onClick={() => checkcloseShift("big", shiftsRow, data)}
                                            >
                                                {t("large_print_and_close")}
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                disabled={showCashOnly ? true : fetching}
                                                variant="contained"
                                                startIcon={<PrintIcon />}
                                                color="primary"
                                                size="large"
                                                className={[clasui.button]}
                                                style={
                                                    (inshst.sal.iconBtn,
                                                        { borderRadius: 0 })
                                                }
                                                onClick={() => printHandleA4(shiftsRow, data)}
                                            >
                                                {"معاينة كبير "}
                                            </Button>
                                        </Grid>
                                    </>
                                )}
                                {showButtons && shiftsRow.transClose == 0 && (
                                    <>
                                        <Grid item>
                                            <Button
                                                disabled={showCashOnly ? true : fetching}
                                                variant="contained"
                                                startIcon={<PrintIcon />}
                                                color="primary"
                                                size="large"
                                                className={[clasui.button]}
                                                style={
                                                    (inshst.sal.iconBtn,
                                                        { borderRadius: 0 })
                                                }
                                                onClick={() => checkcloseShift("small", shiftsRow, data)}
                                            >
                                                {t("small_print_and_close")}
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                disabled={showCashOnly ? true : fetching}
                                                variant="contained"
                                                startIcon={<PrintIcon />}
                                                color="primary"
                                                size="large"
                                                className={[clasui.button]}
                                                style={
                                                    (inshst.sal.iconBtn,
                                                        { borderRadius: 0 })
                                                }
                                                onClick={() => printHandleCashier(shiftsRow, data)}
                                            >
                                                {"معاينة كاشير "}
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                disabled={showCashOnly ? true : fetching}
                                                variant="contained"
                                                startIcon={<PrintIcon />}
                                                color="primary"
                                                size="large"
                                                className={[clasui.button]}
                                                style={(inshst.sal.iconBtn, { borderRadius: 0 })}
                                                onClick={() => printHandleGroups(shiftsRow, data)}
                                            >
                                                {"تفصيلي حسب مجموعات"}
                                            </Button>
                                        </Grid>
                                    </>
                                )}

                                {openUpdate &&
                                    <Grid item>
                                        <Button
                                            disabled={ fetching}
                                            variant="contained"
                                            startIcon={<PrintIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => checkcloseShift("close", shiftsRow, data)}
                                        >
                                            {t("update shifts")}
                                        </Button>
                                    </Grid>

                                }
                                {showButtons && shiftsRow.transClose == 1 && (
                                    <Grid item>
                                        <Button
                                            disabled={showCashOnly ? true : fetching}
                                            variant="contained"
                                            startIcon={<PrintIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => printHandleCashier(shiftsRow, data)}
                                        >
                                            {t("cashier-view")}
                                        </Button>
                                    </Grid>
                                )}
                                {showButtons && shiftsRow.transClose == 1 && (
                                    <Grid item>
                                        <Button
                                            disabled={showCashOnly ? true : fetching}
                                            variant="contained"
                                            startIcon={<PrintIcon />}
                                            color="primary"
                                            size="large"
                                            className={[clasui.button]}
                                            style={
                                                (inshst.sal.iconBtn,
                                                    { borderRadius: 0 })
                                            }
                                            onClick={() => printHandleA4(shiftsRow, data)}
                                        >
                                            {t("great-view")}
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        startIcon={<KeyboardReturnSharpIcon />}
                                        color="secondary"
                                        size="large"
                                        className={[clasui.button, clasSp.clcan]}
                                        style={
                                            (inshst.sal.iconBtn,
                                                { borderRadius: 0 })
                                        }
                                        onClick={() => his.goBack()}
                                    >
                                        {t("forms:exit")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Container>
                        <Container maxWidth={true} style={{ padding: "4px" }}>
                            <Grid container spacing={1} style={{ paddingTop: "10px" }}>
                                {!showCashOnly &&
                                    <>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <TotalCard
                                                {...{
                                                    className: null,
                                                    title: isUser ? "مبلغ الصندوق الفعلي" : t("net_cash2"),
                                                    value: data?.totals?.totRsedStok.toFixed(2),

                                                }}
                                            />
                                        </Grid>

                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <TotalCard
                                                {...{
                                                    className: null,
                                                    title: t("net_network"),
                                                    value: data?.totals?.totRsedNetW.toFixed(2),

                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <TotalCard
                                                {...{
                                                    className: null,
                                                    title: t("net_bank"),
                                                    value: data?.totals?.totBanks.toFixed(2),

                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <TotalCard
                                                {...{
                                                    className: null,
                                                    title: t("net_foward"),
                                                    value: data?.totals?.totAgels.toFixed(2),
                                                }}
                                            />
                                        </Grid>
                                    </>

                                }
                                {data && parseInt(permUser?.accClose) > 0 && parseInt(permUser?.accPlus) > 0 && parseInt(permUser?.accMinus) > 0
                                    && permUser?.useShift &&
                                    <>
                                        <Grid item lg={4} md={4} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField fullWidth variant="outlined" size="small"
                                                id="saleAmount"
                                                label={"المبلغ النقدي المستلم"}
                                                className={clasTF.rootSale}
                                                InputLabelProps={{ className: claslbls.clrSale }}
                                                type="number"
                                                name="saleAmount"
                                                disabled={shiftsRow.transClose==1&&!openUpdate}
                                                value={permUser.saleAmount}
                                                onChange={changAmountdata("saleAmount")}
                                            />
                                        </Grid>
                                        {!showCashOnly &&
                                            <>
                                                <Grid item lg={4} md={4} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                                    <TextField fullWidth variant="outlined" size="small"
                                                        id="saleAmount"
                                                        label={"الفائض"}
                                                        className={clasTF.rootSale}
                                                        inputProps={{ readOnly: true }}
                                                        InputLabelProps={{ className: claslbls.clrSale }}
                                                        type="number"
                                                        name="plus"
                                                        value={parseFloat(permUser.deffAmount) > 0 ? permUser.deffAmount : 0}
                                                    />
                                                </Grid>
                                                <Grid item lg={4} md={4} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                                    <TextField fullWidth variant="outlined" size="small"
                                                        id="saleAmount"
                                                        label={"العجز"}
                                                        className={clasTF.rootSale}
                                                        inputProps={{ readOnly: true }}
                                                        InputLabelProps={{ className: claslbls.clrSale }}
                                                        type="number"
                                                        name="minus"
                                                        value={ parseFloat(permUser.deffAmount) < 0 ? parseFloat(-1*permUser.deffAmount ): 0}
                                                    />
                                                </Grid>
                                            </>
                                        }
                                    </>}

                                {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <TotalCard
                                        {...{
                                            className: null,
                                            title:t("net_old_foward"),
                                            value: data?.totalsold?.totDeptOld.toFixed(2),
                                        }}
                                    />
                                </Grid> */}

                                {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <TotalCard
                                        {...{
                                            className: null,
                                            title: "Totals Due Inv Today",
                                            value: data?.totalsold?.totDueInv.toFixed(2),
                                        }}
                                    />
                                </Grid> */}
                            </Grid>

                        </Container>
                        <br />
                    </Grid>
                    <Grid container lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.green[300]} />
                                    {!fetching && !showCashOnly && (
                                        <ShiftsReportTable
                                            {...{
                                                data: data?.shiftsData ? data.shiftsData : [],
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
            </Typography>
            {exitDialog.isOpen && (
                <ExitConfirmDialog
                    exitDialog={exitDialog}
                    setExitDialog={setExitDialog}
                />
            )}
            {infoPrint ? <ShiftsPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}
        </div>
    );
}
